export const GMAIL_CONNECTION_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  SYNCING: "syncing",
} as const;

export const GMAIL_CONNECTION_STATUS_LABELS = {
  [GMAIL_CONNECTION_STATUS.ACTIVE]: "Connected",
  [GMAIL_CONNECTION_STATUS.INACTIVE]: "Disconnected",
  [GMAIL_CONNECTION_STATUS.SYNCING]: "Syncing",
} as const;

export const GMAIL_CONNECTION_TOAST_KEYS = {
  DISCONNECT: "gmail-disconnect",
  CONNECT: "gmail-connect",
};
